export function isEmpty(arr: ReadonlyArray<unknown> | undefined): boolean {

  return !Array.isArray(arr) || arr.length === 0;
}

export function peek<T>(array: T[]) {
  if (isEmpty(array)) {
    return undefined;
  }

  return array[array.length - 1];
}

export function pop<T>(array: T[]) {
  if (isEmpty(array)) {
    return undefined;
  }

  return array.pop();
}